import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDE6pl5Im0-8OthG48zFjMVzB8NHy-lMxc",
  authDomain: "adminsaludjusticia.firebaseapp.com",
  projectId: "adminsaludjusticia",
  storageBucket: "adminsaludjusticia.appspot.com",
  messagingSenderId: "659413066624",
  appId: "1:659413066624:web:2afa331df91714833fd765",
  measurementId: "G-5R4TL591M8",
};

export const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);


